import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSavedSearchBtnEnabled = isEnabled => ({
  type: actionTypes.SET_SAVED_FILTERS_BUTTON_ENABLED,
  payload: isEnabled
})
